import { render } from "./AbsencesCalendarTable.vue?vue&type=template&id=6fe4f8af&ts=true"
import script from "./AbsencesCalendarTable.vue?vue&type=script&lang=ts"
export * from "./AbsencesCalendarTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__